import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useStateRef from 'react-usestateref'
import useInterval from '@use-it/interval'
import { decode, encode } from "@msgpack/msgpack";
import { Client, Message } from '@stomp/stompjs';
import axios from "axios"
import { setWindowConnectionState } from '../websocket_connection.jsx'

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export default function RabbitMqConnection({ onMessageCompleted, channels, ...props}) {

  const rabbitMqConfig = useSelector(state => state.websocket?.rabbitmq)

  // old video rooms
  if(!rabbitMqConfig || !rabbitMqConfig.enabled) {
    console.warn("Rabbitmq disabled", rabbitMqConfig)
    return <></>
  }

  const [renderedConnectionState, setConnectionState, connectionState] = useStateRef("connecting")


  // const rabbitMqUsername = useSelector(state => state.rabbitMqUsername)
  // const rabbitMqPassword = useSelector(state => state.rabbitMqPassword)

  const [connectionRetries, setConnectionRetries] = useState(0)

  const rabbitMqConnectionUrl = window.location.host == "localhost:3000" ? 'ws://' + window.location.hostname + ":15674/ws" : 'wss://' + window.location.hostname + "/ws"



  const onDisconnect = (frame) => {
    console.error("[RABBITMQ] Disconnected", frame)
    setWindowConnectionState("rabbit", false)
    setConnectionState("closed")
  }
  const beforeConnect = (frame) => {
    console.error("[RABBITMQ] beforeConnect", frame, rabbitMqConnectionUrl)
    setConnectionRetries(connectionRetries + 1)
    setConnectionState("connecting")
    console.log(connectionRetries + 1)
    if(connectionRetries > 5) {
      //setUseRabbitMqConnection(false)
    }
  }
  const onWebSocketClose = (frame) => {
    console.error("[RABBITMQ] onWebSocketClose ", frame)
    setConnectionState("closed")
  }
  const onConnect = (frame) => {
    console.debug("[RABBITMQ] onConnect", frame)
    setConnectionState("connected")
    setWindowConnectionState("rabbit", true)
    console.debug("[RABBITMQ] Connecting to", channels)
    // Do something, all subscribes must be done is this callback
    // This is needed because this will be executed after a (re)connect
    // subscribe('bet_channel', 'CABLE_BET')
    // subscribe('chat_message_channel', 'CABLE_CHAT_MESSAGE')
    // subscribe('event_channel', 'CABLE_EVENT')
    // subscribe('event_question_channel', 'CABLE_EVENT_QUESTION')
    // subscribe('html_content_channel', 'CABLE_HTML_CONTENT')
    // subscribe('media_file_channel', 'CABLE_MEDIA_FILE')
    // subscribe('video_room_channel', 'CABLE_VIDEO_ROOM')
    //const fchannels = ["public"]
    channels.map(channelName => {
      const isTagOwnerChannel = channelName.substr(0,3) == "TO_"
      const cName = isTagOwnerChannel ? "/topic/tag_owner_channel." + channelName : "/queue/" + channelName
      // if(isTagOwnerChannel) { 
      //   return
      // }
      //if(!(channelName.endsWith("_channel") || channelName == "public")) {
        //return
      //}

      const channelArgs = isTagOwnerChannel ? {
        //id: cName,
        "ack": 'client',
        //name: rabbitMqConfig.read_queue_base_path + new Date().getTime(),
        //"x-queue-type": "stream", 
        //"x-stream-offset": "next", 
        //"prefetch-count": 10,
        //'auto-delete': true,
        // "x-ha-mode": "exactly",
        // "x-ha-params": 2,
        "durable": false,
        exclusive: true,
        "x-queue-name": rabbitMqConfig.channel_params.private_channel_name
      } : Object.assign({}, rabbitMqConfig.channel_params, {
        //id: cName,
        "ack": 'client',
        //id: rabbitMqConfig.read_queue_base_path + new Date().getTime(),
        "x-queue-type": "stream", 
        "x-stream-offset": "next", 
        "prefetch-count": 10,
        //'auto-delete': false,
        //"durable": true,
        //exclusive: false
      })

      console.debug("[RABBITMQ] Connecting to", cName, "via", rabbitMqConnectionUrl, channelArgs, rabbitMqConfig.channel_params)

      const subscription = client.subscribe(cName,  function (message) {
        message.ack()
        console.warn({message})
        if (message.body) {
          //const rawData = decode(message.binaryBody)
          console.debug('[RABBITMQ] got message in channel ' + cName + ' with body ', message.body);
          const data = JSON.parse(message.body)
          try {
            onMessageCompleted("rabbitmq", data.id, data)
          } catch(ex) {
            console.error(ex)
          }
        } else {
          console.error('[RABBITMQ] got empty message');
        }
        //console.log("message ack", message.ack())
      }, channelArgs)
      //console.log({subscription})
    })
  }
  const onStompError = (frame) => {
    // Will be invoked in case of error encountered at Broker
    // Bad login/passcode typically will cause an error
    // Complaint brokers will set `message` header with a brief message. Body may contain details.
    // Compliant brokers will terminate the connection after any error
    //setUseRabbitMqConnection(false)
    console.error('[RABBITMQ] Broker reported error: ' + frame.headers['message']);
    console.error('[RABBITMQ] Additional details: ' + frame.body);
    setWindowConnectionState("rabbit", false)
  }

  const client = useMemo(() => {
    return new Client({
      brokerURL: rabbitMqConnectionUrl,
      connectHeaders: {
        login: rabbitMqConfig.username,
        passcode: rabbitMqConfig.token,
        host: rabbitMqConfig.host
      },
      logRawCommunication: true,
      debug: function (str) {
        console.debug(str);
      },
      reconnectDelay: 3 * 1000,
      connectionTimeout: 10 * 1000,
      heartbeatIncoming: (window.location.host == "localhost:3000" ? 6 : 10) * 1000,
      heartbeatOutgoing: (window.location.host == "localhost:3000" ? 6 : 10) * 1000,
    })
  }, [rabbitMqConfig])

  window.client = client

  useEffect(() => {
    client.activate();
    return () => {
      console.warn("Unloading rabbit")
      setWindowConnectionState("rabbit", false)
      setConnectionState("closed")
      client.deactivate()
    }
  }, [client])

  useEffect(() => {
    client.onDisconnect = onDisconnect
    client.beforeConnect = beforeConnect
    client.onWebSocketClose  = onWebSocketClose
    client.onConnect = onConnect
    client.onStompError = onStompError
  }, [
    client,
    onDisconnect,
    beforeConnect,
    onWebSocketClose,
    onConnect,
    onStompError,
 ])


  if(false) {
    return <div style={{fontSize: "0.6rem", padding: "10px", backgroundColor: "white"}}>
      <pre>{JSON.stringify(parseJwt(rabbitMqConfig.token), null, 3)}</pre>
      <div className="btn btn-danger btn-sm" onClick={() => { 
          //client.publish({ destination: '/exchange/public', body: encode('Hello world') }); 
          client.publish({ destination: '/queue/public', body: encode('Hello world') }); 

        } }>
        Publish
      </div>
    </div>
  }


  switch(connectionState?.current) {
    case "connecting":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Connecting via RabbitMQ... Try #{connectionRetries}
      </div>
    case "connected":
      if(window.location.host != "localhost:3000") {
        return <></>; // no info needed
      }
      return <div className="network-status network-status-success">
        <i className="fa fa-check"></i>{" "}
        RabbitMQ connected
      </div>
    case "closed":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        RabbitMQ disconnected
      </div>
    case "unloading":
      return <></>
    default:
      return <div className="network-status network-status-danger">Unknown connection state for  RabbitMQ</div>
  }

  return <></>
}
